let AdminMenuId = {
    TABLE: 0,
    USER_MANAGEMENT: 1,
    TEACHER_MANAGEMENT: 2,
    REGISTER_PAYMENT: 3,
    REGISTER_WORKING_TIMES: 4,
    text: ["레슨 시간표", "수강생 관리", "강사 관리", "결제정보 등록", "레슨 정보 등록"]
}
export default AdminMenuId;
